import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http"
import { inject } from "@angular/core"
import { throwError } from "rxjs"
import { catchError } from "rxjs/operators"

import { lgklog } from "@logick/common/logger"

import { MaintenanceService } from "./maintenance.service"

export const maintenanceInterceptor: HttpInterceptorFn = (request, next) => {
    const maintenanceService = inject(MaintenanceService)
    return next(request).pipe(
        catchError((error: unknown) => {
            if (error instanceof HttpErrorResponse && error.status === 503) {
                lgklog.debug("[MaintenanceInterceptor]", "503 -> maintenance")
                maintenanceService.activate()
            }
            return throwError(() => error)
        })
    )
}
